import React, { Component } from 'react'
import { Card, Label, CardLink, CardBody, Form, Input, FormFeedback, FormGroup, Button, UncontrolledCollapse, Row, Col } from 'reactstrap'
import Fetch from '../../Auxiliares/fetch'
import { toast } from 'react-toastify'
import validaciones from '../../Auxiliares/validaciones'

export default class modUsuario extends Component {
    constructor(props) {
        super(props);
        this.state = {
            id: this.props.id,
            year: this.props.nombre.split('-').slice()[0],
            semestre: this.props.nombre.split('-').slice()[1],
            convocatoria: '',
            documentoCheck1: this.props.estado,
            errors: {}
        }
    }

    setValue(field, ev) {
        this.setState({ [field]: ev.target.value }, () => {
            let value;
            switch ([field].toString()) {
                /*case 'nombre':
                    if (validaciones.validar_nombre(this.state.nombre)) {
                        value = validaciones.validar_nombre(this.state.nombre)
                        this.setState(prevState => ({ errors: { ...prevState.errors, nombre: value } }));
                    } else {
                        this.setState({ errors: (delete Array.from(this.state.errors).nombre) });
                    }
                    break;*/

                default:
                    break;
            }
        })
    }

    guardar() {
        const {id, convocatoria, documentoCheck1 } = this.state

        Fetch('/updateInscripcion', {
            method: 'PUT',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({id, convocatoria, activo: documentoCheck1 })
        }).then(Response => {
            this.props.actualizar();
            this.props.cerrar();
        }).catch(err => {
            switch (err.status) {

                case 600:
                    toast.error('Error inesperado')
                    break;

                case 601:
                    toast.error('Esta convocatoria ya existe')
                    break;

                case 604:
                    toast.error('Esta convocatoria no pudo ser registrado')
                    break;

                default:
                    break;
            }
        })
    }

    render() {
        if (this.state.year.toString().length > 3
            && this.state.semestre !== 0
            && this.state.year.toString().match(/^[0-9]+$/) != null) {
            this.state.convocatoria = this.state.year + '-' + this.state.semestre
        }
        else this.state.convocatoria = ''

        var y = new Date()
        return (
            <Card className="border-0">
                <CardBody>
                    <Form method="post" encType="multipart/form-data">
                        <Card className="p-3 text-center">
                            <Col xs="12">Estado de la Convocatoria</Col>
                            <Col xs="12">
                                <Button className={this.state.documentoCheck1 ? "xs-6 bg-success btn-block" : "xs-6 bg-danger btn-block"} onClick={() => this.setState((state) => ({ documentoCheck1: !state.documentoCheck1 }))}>
                                    {this.state.documentoCheck1 ? "Activa" : "Inactiva"}
                                </Button>
                            </Col>
                            <div className="text-danger bold">ASEGÚRSE DE NO TENER MÁS DE UNA CONVOCATORIA ACTIVA A LA VEZ</div>
                        </Card>

                        <br />

                        <FormGroup >
                            <Label> Defina el nuevo año de la Convocatoria</Label>
                            <Input className="w-100" type="number" onChange={this.setValue.bind(this, "year")} placeholder="(Sólo números)" name="year" defaultValue={this.state.year} />
                            <FormFeedback>{this.state.errors.year}</FormFeedback>
                        </FormGroup>

                        <FormGroup>
                            <Label> Defina el nuevo periodo de la Convocatoria</Label>
                            <Input type="select" name="semestre" onChange={this.setValue.bind(this, "semestre")} className="w-100" defaultValue={this.state.semestre || 0}>
                                <option value={0}>Sin seleccionar</option>
                                <option value={1}>Semestre 1</option>
                                <option value={2}>Semestre 2</option>
                            </Input>
                            <FormFeedback>{this.state.errors.semestre}</FormFeedback>
                        </FormGroup>

                        <br />
                        <CardLink>
                            {this.state.convocatoria && !(this.state.year < y.getFullYear()) &&
                                <Col>
                                    ¿Guardar los cambios de la convocatoria {this.state.convocatoria}?
                            </Col>
                            }
                            {!this.state.convocatoria &&
                                <Col>
                                    Defina un periodo para la convocatoria a renombrar
                            </Col>
                            }
                            {(this.state.year < y.getFullYear()) && this.state.convocatoria &&
                                <Col>
                                    El año designado ya ha transcurrido, defina uno nuevo
                            </Col>
                            }
                            <Button color="info" disabled={!this.state.convocatoria || this.state.year < y.getFullYear()} onClick={() => this.guardar()}>Guardar</Button>
                            <Button color="white" onClick={this.props.cerrar} >Cancelar</Button>
                        </CardLink>
                    </Form>
                </CardBody>
            </Card>
        )
    }
}
